import { Q } from '@nozbe/watermelondb'
import { UserSettingsDoc } from 'types/api/changes'
import { CollectionType } from 'types/model'
import Database from '../Database'
import { ISnooze } from 'model/models/Snooze'

export async function allSnooze() {
  const snooze = await Database.getCollection<ISnooze>(CollectionType.Snooze)
    .query()
    .fetch()
  return snooze
}
